import { NEWS_CONFIG } from "../config/newsConfig";

const stripTrailingSlash = (value) => String(value || "").replace(/\/+$/, "");

const normalizePublicUrl = (value) => {
  if (!value || value === "." || value === "./") return "";

  try {
    const url = new URL(value);
    return stripTrailingSlash(`${url.origin}${url.pathname}`);
  } catch {
    const clean = stripTrailingSlash(String(value));
    if (!clean || clean === ".") return "";
    return clean.startsWith("/") ? clean : `/${clean}`;
  }
};

const getBasePathFromStaticAssets = () => {
  if (typeof document === "undefined" || typeof window === "undefined") {
    return "";
  }

  const elements = [
    ...document.querySelectorAll("script[src]"),
    ...document.querySelectorAll("link[href]"),
  ];

  for (const element of elements) {
    const rawUrl = element.getAttribute("src") || element.getAttribute("href");
    if (!rawUrl) continue;

    try {
      const url = new URL(rawUrl, window.location.href);
      const staticIndex = url.pathname.indexOf("/static/");

      if (staticIndex >= 0) {
        return stripTrailingSlash(url.pathname.slice(0, staticIndex));
      }
    } catch {
      // Ignore invalid asset URLs.
    }
  }

  return "";
};

const getBasePathFromNewsRoute = () => {
  if (typeof window === "undefined") return "";

  const pathname = window.location.pathname || "/";
  const prefix = NEWS_CONFIG.sharePathPrefix || "/news/";
  const normalizedPrefix = prefix.startsWith("/") ? prefix : `/${prefix}`;
  const newsIndex = pathname.indexOf(normalizedPrefix);

  if (newsIndex > 0) {
    return stripTrailingSlash(pathname.slice(0, newsIndex));
  }

  return "";
};

export const getAppBasePath = () => {
  return (
    normalizePublicUrl(process.env.PUBLIC_URL) ||
    getBasePathFromStaticAssets() ||
    getBasePathFromNewsRoute()
  );
};

export const getSiteHomePath = () => {
  const basePath = getAppBasePath();
  return basePath ? `${basePath}/` : "/";
};

export const getPublicAssetBasePath = () => {
  return getAppBasePath();
};

export const buildPublicAssetUrl = (assetPath) => {
  const cleanAssetPath = String(assetPath || "").replace(/^\.\//, "").replace(/^\//, "");
  const basePath = getPublicAssetBasePath();

  return basePath ? `${stripTrailingSlash(basePath)}/${cleanAssetPath}` : `/${cleanAssetPath}`;
};

export const getSharedNewsIdFromLocation = () => {
  if (typeof window === "undefined") return null;

  const prefix = NEWS_CONFIG.sharePathPrefix || "/news/";
  const normalizedPrefix = prefix.startsWith("/") ? prefix : `/${prefix}`;
  const escapedPrefix = normalizedPrefix.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const match = window.location.pathname.match(
    new RegExp(`${escapedPrefix}(\\d+)\\/?$`)
  );

  return match ? match[1] : null;
};

export const buildInternalNewsUrl = (news) => {
  if (typeof window === "undefined") return "";

  const id = news?.id;
  const homePath = getSiteHomePath();
  const shareBaseUrl =
    stripTrailingSlash(NEWS_CONFIG.shareBaseUrl) || window.location.origin;

  if (id === undefined || id === null) {
    return `${shareBaseUrl}${homePath}`;
  }

  const cleanHomePath = homePath.replace(/\/$/, "");
  return `${shareBaseUrl}${cleanHomePath}${NEWS_CONFIG.sharePathPrefix}${id}`;
};
